module.exports = __webpack_public_path__ + "img/balance.f0b16612.svg";